module.exports = __webpack_public_path__ + "static/media/documents.c4a0e7ff.md";